import { FAQ } from '@/constants/faq';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
} from '@chakra-ui/react';
import { isMobile } from 'react-device-detect';

const Faq = () => {
  return (
    <section className='relative w-[90%] md:w-[80%] h-full mx-auto py-20 box-border flex flex-col gap-4'>
      <h2 className='mb-8 md:my-12 md:mb-20 !text-xl md:!text-[2.5rem] font-bold text-center text-[#001326]'>
        Frequently Asked Questions
      </h2>
      <Accordion
        allowToggle
        border={'1px solid lightgray'}
        borderRadius={'1rem'}
        padding={'1rem'}
      >
        {FAQ.map((faq, index) => {
          return (
            <AccordionItem key={index} color={'#001326'}>
              <h2 style={{ margin: '0', padding: '0' }}>
                <AccordionButton
                  bg={'transparent'}
                  padding={'1rem 2rem'}
                  border={'none'}
                  cursor={'pointer'}
                  _hover={{
                    bg: '#E9E9E9',
                    borderRadius: '1rem',
                  }}
                >
                  <Box
                    flex='1'
                    textAlign='left'
                    fontWeight={'900'}
                    color={'#001326'}
                    className='!text-base md:!text-[1.5rem]'
                  >
                    {faq.question}
                  </Box>
                  <AccordionIcon
                    w={isMobile ? '1.25rem' : '1.5rem'}
                    height={isMobile ? '1.25rem' : '1.5rem'}
                  />
                </AccordionButton>
              </h2>
              <AccordionPanel
                margin={'0.5rem 2rem'}
                padding={'0.5rem 1rem'}
                borderRadius={'1rem'}
                bg={'#fccb16a0'}
                whiteSpace='pre-line'
                className='!text-sm md:!text-[1.2rem]'
              >
                {faq.answer}
              </AccordionPanel>
            </AccordionItem>
          );
        })}
      </Accordion>
    </section>
  );
};

export default Faq;
